export default __webpack_public_path__ + "static/media/marker_filled_blue.4a4ff5c1.svg";